import en from './en';
import { panelDwiOverrides } from './partials/panelDwiOverrides';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelWithdrawBep20ByLang } from './partials/panelWithdrawBep20I18n';
import { panelDepositVoucherOverrides } from './partials/panelDepositVoucherOverrides';
import { panelInvestmentsOverrides } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignOverrides } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralRankingByLang } from './partials/panelReferralRankingI18n';

function m(p) {
  return { ...en, ...p };
}

export default m({
  'common.theme': 'Tema',
  'common.themeLight': 'Chiaro',
  'common.themeDark': 'Scuro',
  'common.themeActive': 'Attualmente attivo',
  'common.themeSwitchToDark': 'Passa al tema scuro',
  'common.themeSwitchToLight': 'Passa al tema chiaro',
  'common.settings': 'Impostazioni',
  'common.loading': 'Caricamento…',
  'settings.language': 'Lingua',
  'settings.savePreferences': 'Salva preferenze',
  'settings.savingPreferences': 'Salvataggio…',
  'auth.gate.userTitle': 'Verifica sessione',
  'auth.gate.userDescription': 'Conferma accesso in corso.',
  'auth.gate.agentTitle': 'Verifica sessione',
  'auth.gate.agentDescription': 'Conferma accesso agente in corso.',
  'user.layout.sidebarTitle': 'MineMe Utente',
  'user.layout.logout': 'Esci',
  'user.layout.nav.dashboard': 'Dashboard',
  'user.layout.nav.deposit': 'Deposito',
  'user.layout.nav.withdraw': 'Prelievo',
  'user.layout.nav.investments': 'Investimenti',
  'user.layout.nav.referral': 'Referral',
  'user.layout.nav.notifications': 'Notifiche',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transazioni',
  'user.layout.nav.settings': 'Impostazioni',
  'user.layout.balance.available': 'Saldo disponibile',
  'user.layout.balance.frozen': 'Saldo bloccato',
  'user.layout.balance.interest': 'Saldo interessi',
  'user.layout.balance.bonus': 'Saldo bonus',
  'user.dashboard.balance.available': 'Saldo disponibile',
  'user.dashboard.balance.frozen': 'Saldo bloccato',
  'user.dashboard.balance.interest': 'Interessi maturati',
  'user.dashboard.balance.bonus': 'Saldo bonus',

  'common.time.days': 'Giorni',
  'common.time.hours': 'Ore',
  'common.time.minutes': 'Minuti',
  'common.time.seconds': 'Secondi',

  'user.dashboard.title': 'Dashboard',
  'user.dashboard.loadingInvestments': 'Caricamento stato investimenti…',
  'user.dashboard.stats.totalInvested': 'Totale investito',
  'user.dashboard.stats.netPnl': 'Utile / perdita netta',
  'user.dashboard.stats.activePlans': 'Piani attivi',
  'user.dashboard.noInvestment.title': 'Nessun investimento attivo',
  'user.dashboard.noInvestment.subtitle':
    'Inizia a investire oggi e fai crescere il tuo patrimonio con rendimenti interessanti',
  'user.dashboard.noInvestment.cta': 'Scopri i piani di investimento',
  'user.dashboard.recentTx.title': 'Transazioni recenti',
  'user.dashboard.recentTx.viewAll': 'Vedi tutte',
  'user.dashboard.recentTx.col.date': 'Data',
  'user.dashboard.recentTx.col.type': 'Tipo',
  'user.dashboard.recentTx.col.description': 'Descrizione',
  'user.dashboard.recentTx.col.amount': 'Importo',
  'user.dashboard.recentTx.col.status': 'Stato',
  'user.dashboard.recentTx.loading': 'Caricamento transazioni recenti…',
  'user.dashboard.recentTx.empty': 'Nessuna transazione recente.',
  'user.dashboard.tx.Deposit': 'Deposito',
  'user.dashboard.tx.Investment': 'Investimento',
  'user.dashboard.tx.Referral': 'Referral',
  'user.dashboard.tx.Bonus': 'Bonus',
  'user.dashboard.tx.Withdrawal': 'Prelievo',
  'user.dashboard.tx.E-Voucher': 'Buono elettronico',
  'user.dashboard.tx.Stop-Loss': 'Stop-loss',
  'user.dashboard.st.Completed': 'Completato',
  'user.dashboard.st.Active': 'Attivo',
  'user.dashboard.st.Pending': 'In sospeso',
  'user.dashboard.st.Failed': 'Non riuscito',
  'user.dashboard.invest.planFallback': 'Piano',
  'user.dashboard.invest.activeBadge': 'Attivo',
  'user.dashboard.invest.detail.amountInvested': 'Importo investito',
  'user.dashboard.invest.detail.currentValue': 'Valore attuale',
  'user.dashboard.invest.detail.pl': 'U/P',
  'user.dashboard.invest.detail.interestRate': 'Tasso di interesse',
  'user.dashboard.invest.detail.perMonth': '{{pct}}% al mese',
  'user.dashboard.invest.detail.duration': 'Durata',
  'user.dashboard.invest.detail.months': '{{n}} mesi',
  'user.dashboard.invest.detail.startDate': 'Data di inizio',
  'user.dashboard.invest.detail.nextWithdrawal': 'Prossimo prelievo',
  'user.dashboard.invest.countdownTitle': 'Prossimo prelievo tra',
  'user.dashboard.invest.progress': 'Avanzamento',
  'user.dashboard.invest.progressPct': '{{pct}}% completato',
  'user.dashboard.invest.earlyWithdraw': 'Prelievo anticipato',
  'user.dashboard.invest.planChip': '{{name}} n. {{num}}',
  'user.dashboard.invest.modal.title': 'Avviso: prelievo anticipato',
  'user.dashboard.invest.modal.investmentAmount': 'Importo investito:',
  'user.dashboard.invest.modal.platformFee': 'Commissione piattaforma ({{pct}}%):',
  'user.dashboard.invest.modal.interestForfeited': 'Interessi persi:',
  'user.dashboard.invest.modal.youWillReceive': 'Riceverai:',
  'user.dashboard.invest.modal.confirmHint': 'Digita CONFIRM per continuare',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Conferma prelievo',
  'user.dashboard.invest.modal.cancelling': 'Annullamento…',
  'user.dashboard.invest.toast.cancelled': 'Investimento annullato',
  'user.dashboard.invest.toast.cancelFailed': 'Impossibile annullare',

  'notifications.bell.triggerAria': 'Notifiche',
  'notifications.bell.title': 'Notifiche',
  'notifications.bell.loading': 'Caricamento…',
  'notifications.bell.loadErrorSubtitle': 'Impossibile caricare le notifiche',
  'notifications.bell.unreadOne': '1 aggiornamento non letto',
  'notifications.bell.unreadMany': '{{count}} aggiornamenti non letti',
  'notifications.bell.allCaughtUp': 'Sei aggiornato',
  'notifications.bell.markAllRead': 'Segna tutte come lette',
  'notifications.bell.empty': 'Ancora nessuna notifica',
  'notifications.bell.emptyError': 'Impossibile caricare le notifiche',
  'notifications.bell.viewAll': 'Vedi tutte',
  'notifications.bell.markReadAria': 'Segna come letta',
  'notifications.bell.time.justNow': 'adesso',
  'notifications.bell.time.secondsAgo': '{{n}} s fa',
  'notifications.bell.time.minutesAgo': '{{n}} min fa',
  'notifications.bell.time.hoursAgo': '{{n}} h fa',
  'notifications.bell.time.daysAgo': '{{n}} g fa',

  'agent.layout.logout': 'Esci',
  'agent.layout.nav.dashboard': 'Dashboard',
  'auth.user.login.title': 'Accesso utente',
  'auth.user.login.signIn': 'Accedi',
  'auth.agent.login.title': 'Accesso agente',
  'auth.agent.login.signIn': 'Accedi',

  ...panelSettingsTransactionsByLang.it,
  ...panelReferralRankingByLang.it,
  ...panelUserExtraByLang.it,
  ...panelDwiOverrides.it,
  ...panelDepositBonusByLang.it,
  ...panelVoucherStatusByLang.it,
  ...panelWithdrawBep20ByLang.it,
  ...panelDepositVoucherOverrides.it,
  ...panelInvestmentsOverrides.it,
  'user.investments.card.dailyProfit': 'Profitto giornaliero',
  'user.investments.card.earningDays': 'Giorni lavorativi',
  'user.investments.card.earningDaysValue': '{{count}} giorni lavorativi',
  'user.investments.card.expectedProfit': 'Profitto atteso',
  'user.investments.card.investLimit': 'Limite investimento',
  'user.investments.card.investLimitLine': '{{count}}× in {{days}} giorni',
  'user.investments.card.investLimitReached':
    'Hai raggiunto il limite di investimento per questo piano nel periodo corrente.',
  'user.investments.card.limitReached': 'Limite raggiunto',
  ...panelStopLossSlotsAssignOverrides.it,
  ...panelStopLossFlowByLang.it,
  ...panelUserSignupSocialForgotByLang.it,
  ...panelAgentDashboardByLang.it,
  ...panelAgentReferralsByLang.it,
  ...panelAgentCommissionsByLang.it,
  ...panelAgentWithdrawByLang.it,
  ...panelAgentWithdrawUnlockStringsByLang.it,
  'agent.withdraw.unlock.loadingTitle': 'Verifica stato prelievi…',
  'agent.withdraw.unlock.loadingSubtitle': 'Caricamento progresso referral e requisiti di sblocco',
  'agent.withdraw.form.loadingTitle': 'Caricamento dettagli prelievo…',
  'agent.withdraw.form.loadingHint': 'Attendere il caricamento del saldo e dello stato di sblocco',
  'agent.withdraw.unlock.requirementMet': 'Requisito soddisfatto',
  'agent.withdraw.unlock.minDepositHint':
    'Contano solo gli utenti referenziati (non i sub-agent). Ognuno deve avere almeno ${{amount}} in depositi completati.',
  ...panelAgentTransactionsByLang.it,
  ...panelAgentLogsByLang.it,
  ...panelAgentSettingsByLang.it,
  ...panelAgentNotificationsByLang.it,
  ...panelAgentTeamByLang.it,
  ...panelAgentSignupByLang.it,
  ...panelAgentLayoutByLang.it,
  ...panelAgentAuthByLang.it,
  ...panelUserPlatformTodayByLang.it,
  ...panelStopLossHowLayoutByLang.it,
  ...panelSupportTicketsByLang.it,
});
